export default {
    edit: "编辑",
    location: "地点 + 条款和条件",
    filter: "筛选"
}
